import { useCallback } from 'react';
import _ from 'lodash';

import { LINK_EXPIRED_ERROR_TEXT } from '@/modules/user/components/ResetPassword/resetPassword.types';

import useValidateResetLinkQuery from '../queries/useValidateResetLink.query';
import { ResetPasswordStep } from '../resetPassword.types';

interface Props {
  setStep?: (step: ResetPasswordStep) => void;
}

const useValidateResetLink = ({ setStep }: Props) => {
  const { validateResetLinkQuery } = useValidateResetLinkQuery();

  const validateResetLink = useCallback(async (linkId: string) => {
    try {
      const response = await validateResetLinkQuery(linkId);
      if (response.data?.valid) {
        setStep?.(ResetPasswordStep.RESET_PASSWORD);
        return;
      } else {
        setStep?.(ResetPasswordStep.LINK_INVALID);
      }
    } catch (error: unknown) {
      const elevateErrorMessage = _.get(error, 'response.data.elevate_error_message', '') as string;
      if (elevateErrorMessage.includes(LINK_EXPIRED_ERROR_TEXT)) {
        setStep?.(ResetPasswordStep.LINK_EXPIRED);
        return;
      } else {
        setStep?.(ResetPasswordStep.LINK_INVALID);
      }
    }
  }, [setStep, validateResetLinkQuery]);

  return {
    validateResetLink
  };
};

export default useValidateResetLink;
